// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603111425/js/" + chunkId + "." + {"44":"d9e5ed9a","225":"a11a115f","481":"5f0cd1b6","486":"e80c93c1","770":"037cbfd4"}[chunkId] + ".0.9464894191937967.chunk.js";
};